import React from "react";

const TeamRep = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="404.991"
        height="298.589"
        viewBox="0 0 404.991 298.589"
      >
        <g id="teamRep" transform="translate(-768.028 -1449.042)">
          <g id="undraw_stand_out_1oag" transform="translate(760.543 1449.045)">
            <path
              id="Path_60"
              data-name="Path 60"
              d="M789.677,320.715c-.771-2.008.331-3.012.771-4.8s-.992-7.362-.992-7.362-4.628-19.3-6.06-23.09a6.936,6.936,0,0,0-3.24-3.45c-.089-.492-.218-.81-.4-.9a30.547,30.547,0,0,0-6.575-2.438,10.874,10.874,0,0,0-1.4-1.918,4.58,4.58,0,0,0,.5-2.348c-.135-2.1-1.709-3.99-1.5-6.089.155-1.592,1.3-2.9,1.748-4.434a5.269,5.269,0,0,0-.585-4.112l.978,1.053a3.735,3.735,0,0,0-.273-4.469c-1.032-1.154-2.758-1.587-3.559-2.916-.823-1.366-.381-3.222-1.159-4.614-1.906-3.411-6.786-.993-9.708-2.184a7.99,7.99,0,0,0-3.465-.989,13.394,13.394,0,0,0-3.38.639,7.146,7.146,0,0,0-3.874,2.811,2.424,2.424,0,0,1,.3-.293,1.554,1.554,0,0,1,2.324.313,1.4,1.4,0,0,1,.109.662,3.1,3.1,0,0,1-1.78,2.244,6.694,6.694,0,0,0-2.379,1.743c-.922,1.362-.38,3.19-.38,4.841a7.05,7.05,0,0,1-2.628,5.45l3.109-1.287a23.987,23.987,0,0,0-2.871,8.524l4.2-3.516a18.869,18.869,0,0,0-2.761,8.307l3.374-3.5a1.744,1.744,0,0,1,.223.9L748,274.87a8.96,8.96,0,0,1-.413.8c-.543.944-1.1,2.106-.6,3.069h0c-.535,1.821-1.341,3.643-3.135,4.528a5.2,5.2,0,0,0,4.965-2.4,4.493,4.493,0,0,0,.528.81l.172.219-.5.335-1.329.9s-8.7,1.785-8.154,5.131l.08.486-2.5,4.31-3.636,12.493s-1.873,4.016-1.543,5.689,0,2.342,0,5.354-1.432,4.239,0,6.693,5.73,9.593,5.73,9.593l.944.717a4.52,4.52,0,0,0,.048,1.291c.881,4.462,9.146,47.184,9.146,47.184s-4.187,33.8,4.3,35.918c1.064.266,2.109.507,3.124.722l1.283,8.537-.771,10.82s-5.84,13.386,4.848,14.166,5.84-11.6,5.84-11.6a5.942,5.942,0,0,0,.661-3.458c-.109-.993-1.026-6.16-1.926-11.13,4.056-.492,3.3-4.85,2.757-6.766a1.108,1.108,0,0,0,.492-.62,19.257,19.257,0,0,0-.678-4.648c-.42-2.438-1.138-6.386-1.628-9.06l2.636.435,11.129-66.035s.073-1.051.04-2.589a41.046,41.046,0,0,1,4.7-2.1c3.636-1.45,5.069-6.8,6.281-9.035S790.448,322.723,789.677,320.715ZM750.164,278.67a2.338,2.338,0,0,1,1.219-.418c-.094.519-.976.67-1.715.942a2.2,2.2,0,0,1,.5-.524ZM744.611,311.9c.893,1.485-.724,5.508-2.18,8.7-.835-.728-1.706-.5-.685-2.566a10.59,10.59,0,0,0,1.212-4.239,4.111,4.111,0,0,1,1.215-2.908,5.9,5.9,0,0,0,.438,1.012Zm-3.344,12.814c.505-.208,1.27-.528,2.3-.884-.495.658-1.06,1.441-1.628,2.3a1.736,1.736,0,0,1-.675-1.413Zm35.739,1.464c-.67-.721-1.211-1.365-1.657-1.942q1.247.332,2.538.715a2.984,2.984,0,0,0,1.284-.087c.038.771.038,1.871.038,1.871l-1.207.846a7.165,7.165,0,0,0-1-1.4Zm3.419-3.869-.04.036a7.474,7.474,0,0,0-.294-1.3,49.4,49.4,0,0,1-1.313-9.887l2.085,7.1s.11,3.57-.437,4.051Z"
              transform="translate(-468.605 -185.312)"
              fill="#d0cde1"
            />
            <path
              id="Path_61"
              data-name="Path 61"
              d="M654.682,274.854s-11.3-19.669-11.658-21.815-6.006-6.08-6.006-6.08c-1.931-1.955-5.1-2.574-8.434-2.541,1.256-1.052-3.228-1.759-3.577-2.465s-1.413-.715-2.826-1.788-4.94-.179-4.94-.179a13.3,13.3,0,0,1-1.1-3.564,10.045,10.045,0,0,0,2.327-6.449c0-.026,0-.051,0-.077.09.142.18.284.27.431.662-4.013,1.83-7.348-.4-11.009a12.213,12.213,0,0,0-6.936-5.368l-2.121,1.717.824-2a11.09,11.09,0,0,0-2.1-.123l-1.908,2.483.79-2.4a12.051,12.051,0,0,0-8.331,5.017,10.944,10.944,0,0,0,.123,12.044c.008-.025.014-.049.022-.074a10.023,10.023,0,0,0,5.054,8.106l.6,4.859h0a3.271,3.271,0,0,1-1.967.878c-1.06,0-2.12,2.861-2.12,2.861s-.6.307-1.248,1.755c-1.668,1.149-6.755,4.76-8.642,7.282-1.116.556-2.316,1.793-2.121,4.552.353,5.007,0,28.252,0,28.252s-3.179,19.669-2.12,21.1-.353,6.08-.353,6.08l1.06.238v1.192s-3.188,14.959,1.766,14.3c8.125-1.073,2.12-13.232,2.12-13.232v-1.391l1.413.318s.707-5.007,2.12-5.364c.492-.124,1.068-1.461,1.612-3.151l.508,4.224,2.211-.5.616,2.285a3.04,3.04,0,0,0,.475.218l-.475,2.643a18.775,18.775,0,0,0,0,4.649c.178.9,6.736,20.177,13.193,39.064l-.122,4.566s-3.179,3.576-2.473,6.08-1.766,23.245-1.766,23.245l-2.12,10.371.533.166-.49,1.817a3.569,3.569,0,0,0-1.1.878c-2.826,3.219-6.359,12.517-6.359,12.517s-6.359,9.656,3.533,9.3,10.6-3.934,10.6-3.934,1.413-9.3,1.413-9.656-.706-4.034-.706-4.034l-.274-.306.192-4.461,1.849.576s1.766-9.3,3.179-10.371c.494-.375,1.808-4.552,3.308-9.917,1.533,4.47,3.018,19.924,3.5,21.327a5.1,5.1,0,0,0-.449.749,87.122,87.122,0,0,1-5.3,8.94s-11.3,6.795,0,8.583c0,0,6.359.358,9.538-1.788s11.658-5.364,11.658-6.08-2.12-11.229-4.239-10.085h0l-1.42-3.306,1.42-.556-8.944-40.64a20.753,20.753,0,0,0,.465-2.632c0-1.873,4.574-38.339,5.738-47.588,5.123,1.469,9.805-9.274,9.805-9.274l1.161-2.116,1.665,1.043s1.413-3.576,3.533-3.934,6.005-19.312,6.005-21.815a11.759,11.759,0,0,0-1.06-4.649Zm-16.459,28.019a9.624,9.624,0,0,0-1.2-1.555,44.716,44.716,0,0,0,2.12-7.51c.707-3.934-1.06-16.808-1.06-16.808l-.031-.874c1.734,2.3,3.917,5.376,3.917,6.239a2.693,2.693,0,0,0,1.06,2.146l-2.12,7.51a44.846,44.846,0,0,0-1.766,5.364,18.473,18.473,0,0,0-.353,3.219l.5.314Z"
              transform="translate(-385.664 -167.173)"
              fill="#d0cde1"
            />
            <path
              id="Path_62"
              data-name="Path 62"
              d="M289.408,292.987l1.885-.429-7.772-22.173-16.78-6.258s-.064.072-.183.2a9.051,9.051,0,0,1-2.293-5.039,9.963,9.963,0,0,0,5.721-6.253,10.116,10.116,0,0,0-1.111-8.449c1.383-.336,1.876-1.606,2.34-3.12a6.12,6.12,0,0,0-.877-.193l.652-1.481-1.146-.1.293-1.384-1.462,1.022a3.053,3.053,0,0,0-.5-2.887,5.706,5.706,0,0,0-2.445-1.745,10.807,10.807,0,0,0-11.2,1.981l-.106-.417a14.423,14.423,0,0,0-5.427,9.52c-.468,3.732,1.3,7.532,3.6,10.485-.019-.129-.04-.258-.061-.386q.149.208.308.408l.283,10.885-.709.615s-11.89,5.446-12.354,11.95v0c-.714,3.166-1.067,19.617-1.067,19.617h.978l-.978,6.437-6.359,25.033s-8.125,10.729-1.06,12.874c4.39,1.333,5.643-3.823,5.962-7.919a2.489,2.489,0,0,0,2.516,1.84c.118.011.244.02.366.03-3.341,8.74-1.073,37.163-1.073,37.163-1.766,3.576,19.076,28.252,19.076,28.252l1.255-.678.272.55c-.7.068-1.173.128-1.173.128v11.086s-3.179,11.086,1.06,13.232c1.1.555,2.241.151,3.335-.751-.209,3.421-.509,8.527-.509,9.691,0,1.788,4.592,5.007,4.592,5.007s1.06,3.934,9.538,3.934,2.12-10.371,2.12-10.371l-4.592-10.371s-.344.17-1.384-.687l.372-4.147,2.071.185,2.826-41.842s2.473-37.193,2.826-42.915a40.313,40.313,0,0,0-.128-5.5l10.372-21.678Zm-7.653,13.876L280.7,310.6v-8.269Zm-44.1,26.52c.009-1.311-.055-2.2-.055-2.2L244.5,317.2l-.194,4.327S238.778,328.608,237.652,333.383Zm16.195,40.355,6.712-23.961,3.886,28.967-.279,10.531a16.914,16.914,0,0,1-1.134-3.021C261.972,381.963,253.847,373.738,253.847,373.738Z"
              transform="translate(-182.117 -178.687)"
              fill="#d0cde1"
            />
            <path
              id="Path_63"
              data-name="Path 63"
              d="M380.825,422.187c-3.31-1.38-9.735-4.336-10.514-5.913s-4.673-13.8-4.673-13.8l-1,.074c-.129-5.552-.681-27.067-1.528-29.639,0,0,4.089-34.1-4.089-47.7l-1.473-6.026a34.045,34.045,0,0,0,.111-8.954c-.389-1.183,4.478-4.928,3.115-7.293s-5.062-10.447-5.062-10.447.389-5.125-4.868-9.855c0,0-1.536-8.8-8.459-8.936-.936-1.653-2.246-4.282-1.86-5.453.413-1.253,1.991-5.161,2.882-7.348a9.3,9.3,0,0,0,1.359-.766c5.506-2.5,9.387-8.5,9.387-15.513,0-7.507-4.446-13.86-10.573-15.991a5.366,5.366,0,0,0-1.268-5.718,5.207,5.207,0,0,0-5.691-1.069,5.321,5.321,0,0,0-3.208,4.877,5.371,5.371,0,0,1,.464-5.007,5.214,5.214,0,0,1,5.4-2.272,5.217,5.217,0,0,0-6.676,1.93,5.363,5.363,0,0,0,1.049,6.948,5.3,5.3,0,0,0,.215.572c-5.765,2.355-9.878,8.508-9.878,15.728a16.968,16.968,0,0,0,8.654,15.156c-.027,2.179-.561,5.852-3.529,8.09-1.533-.709-3.661-1.488-5.026-1.134-.706-.557-1.771-.741-3.221.726-2.921,2.957-5.452,10.644-5.452,15.374s.584,32.128.584,32.128-3.115,1.183-.974,2.957a2.507,2.507,0,0,0,1.573.592l2.126,15.965s-1.363,15.374,3.894,15.571a2.06,2.06,0,0,0,1.177-.292l-3.9,17.835a59.067,59.067,0,0,0-15.966,17.542,93.942,93.942,0,0,0-6.309,11.844l-1.284-.806-4.478,8.673s-9.93,6.11-7.788,10.644,4.089,5.716,4.089,5.716l1.363-.591,2.531,4.731s6.62,9.658,17.329,4.73a4,4,0,0,0,0-4.73c-1.752-2.562-6.231-8.081-6.231-8.081l2.921-14.98-.6-.379,18.517-22.682s5.452-3.351,7.4-6.307S345.389,339.4,345.389,339.4l6.815,31.931s-.389,11.629,1.363,19.119a82.081,82.081,0,0,1,1.863,12.775l-.5.037,1.168,8.87s-5.062,12.615-1.558,13.6a50.78,50.78,0,0,0,7.594,1.38l.389-1.38s14.992,8.278,20.444,2.168C382.967,427.9,384.135,423.566,380.825,422.187Zm-53.349-96.779c.584.591.389,3.351.389,3.351l-1.168,7.687-1.167,5.332a57.932,57.932,0,0,0-.975-7.5l-.539-14.731a1.118,1.118,0,0,0,.344.146c.389,0,.195-3.351.195-3.351s.227-.6.511-1.543c.757,2.294,1.681,3.791,2.8,4.105l.195,2.562s-2.531,1.183-.195,1.183a1.82,1.82,0,0,0,.4-.06l-.207,1.046S326.892,324.817,327.476,325.408Z"
              transform="translate(-213.497 -170.218)"
              fill="#d0cde1"
            />
            <ellipse
              id="Ellipse_35"
              data-name="Ellipse 35"
              cx="156.515"
              cy="2.612"
              rx="156.515"
              ry="2.612"
              transform="translate(7.486 255.927)"
              fill="#3f3d56"
            />
            <ellipse
              id="Ellipse_36"
              data-name="Ellipse 36"
              cx="172.166"
              cy="6.747"
              rx="172.166"
              ry="6.747"
              transform="translate(46.614 258.539)"
              fill="#3f3d56"
            />
            <ellipse
              id="Ellipse_37"
              data-name="Ellipse 37"
              cx="84.492"
              cy="6.747"
              rx="84.492"
              ry="6.747"
              transform="translate(102.513 268.551)"
              fill="#3f3d56"
            />
            <ellipse
              id="Ellipse_38"
              data-name="Ellipse 38"
              cx="37.624"
              cy="3.482"
              rx="37.624"
              ry="3.482"
              transform="translate(271.497 279.868)"
              fill="#3f3d56"
            />
            <ellipse
              id="Ellipse_39"
              data-name="Ellipse 39"
              cx="17.844"
              cy="3.482"
              rx="17.844"
              ry="3.482"
              transform="translate(239.678 291.621)"
              fill="#3f3d56"
            />
            <ellipse
              id="Ellipse_40"
              data-name="Ellipse 40"
              cx="17.844"
              cy="3.482"
              rx="17.844"
              ry="3.482"
              transform="translate(94.343 276.821)"
              fill="#3f3d56"
            />
            <path
              id="Path_64"
              data-name="Path 64"
              d="M465.909,551.761l1.72,12.188,8.6-.871-.86-12.623Z"
              transform="translate(-265.574 -310.851)"
              fill="#ffb8b8"
            />
            <path
              id="Path_65"
              data-name="Path 65"
              d="M357.229,551.761l-1.72,12.188-8.6-.871.86-12.623Z"
              transform="translate(-197.743 -310.851)"
              fill="#ffb8b8"
            />
            <path
              id="Path_66"
              data-name="Path 66"
              d="M453.957,370.109a32.379,32.379,0,0,0-6.02,23.505c1.72,14.364,4.73,47.011,4.73,47.011l2.15,57.893,13.76-.871,2.15-49.187,6.88-39.611L496.1,454.99s9.03,43.093,9.46,43.093,12.9-1.306,12.9-1.306l-6.02-50.929s-9.46-74-15.049-75.3S453.957,370.109,453.957,370.109Z"
              transform="translate(-306.941 -255.432)"
              fill="#2f2e41"
            />
            <path
              id="Path_67"
              data-name="Path 67"
              d="M596.083,679.775s-7.74-5.223-10.75.871-.43,10.447-.43,10.447,2.58,1.741,1.29,3.482-1.72,13.059,9.46,11.317,5.59-13.494,5.59-13.494Z"
              transform="translate(-384.569 -429.288)"
              fill="#2f2e41"
            />
            <path
              id="Path_68"
              data-name="Path 68"
              d="M456.575,679.775s7.74-5.223,10.75.871.43,10.447.43,10.447-2.58,1.741-1.29,3.482,1.72,13.059-9.46,11.317-5.59-13.494-5.59-13.494Z"
              transform="translate(-308.269 -429.288)"
              fill="#2f2e41"
            />
            <path
              id="Path_69"
              data-name="Path 69"
              d="M486.768,173.154s3.87,10.882.86,16.976,4.73,13.059,4.73,13.059,20.209-10.447,17.629-15.67-6.88-12.188-6.02-16.541Z"
              transform="translate(-329.217 -143.141)"
              fill="#ffb8b8"
            />
            <ellipse
              id="Ellipse_41"
              data-name="Ellipse 41"
              cx="13.76"
              cy="13.929"
              rx="13.76"
              ry="13.929"
              transform="translate(151.316 6.29)"
              fill="#ffb8b8"
            />
            <path
              id="Path_70"
              data-name="Path 70"
              d="M473.288,207.187s13.806,11.63,24.1-4.849l10.726,6.155,5.59,66.164s-31.389,18.282-46.438,2.612l2.15-61.375Z"
              transform="translate(-318.102 -160.85)"
              fill="#d0cde1"
            />
            <path
              id="Path_71"
              data-name="Path 71"
              d="M342.444,91.488l-19.385,13.044,6.88,32.211-9.03,50.058,14.62-22.2Z"
              transform="translate(-182.922 -51.666)"
              fill="#575a89"
            />
            <path
              id="Path_72"
              data-name="Path 72"
              d="M524.258,190.169l4.761,3.181,19.349,6.965-3.01,53.976,8.17,34.823-11.61,6.094s-2.15-16.541-15.48-24.811S521.216,192.647,524.258,190.169Z"
              transform="translate(-347.603 -153.978)"
              fill="#575a89"
            />
            <path
              id="Path_73"
              data-name="Path 73"
              d="M449.428,384.478l5.59,3.918s-7.095,7.617-8.385,6.312a3.593,3.593,0,0,1-1.075-2.829l-1.29-3.047Z"
              transform="translate(-304.991 -263.707)"
              fill="#ffb8b8"
            />
            <path
              id="Path_74"
              data-name="Path 74"
              d="M534.212,382.532l-1.9,3.023s-5.59,2.612-4.3,4.353,12.04,5.659,14.19,1.741l2.15-3.918Z"
              transform="translate(-352.617 -262.608)"
              fill="#ffb8b8"
            />
            <path
              id="Path_75"
              data-name="Path 75"
              d="M440.663,227.478l-3.01.435-4.945,32.429s-1.935,5.876.215,19.806,4.279,23,4.279,23l9.481-6.894-4.3-11.317,5.59-41.352Z"
              transform="translate(-297.946 -175.047)"
              fill="#575a89"
            />
            <path
              id="Path_76"
              data-name="Path 76"
              d="M553.028,211.478l6.88.871s7.74,8.27,9.03,16.976.86,33.517.86,33.517l-19.779,31.776-10.75-7.835,15.05-26.988-7.31-32.211Z"
              transform="translate(-359.143 -166.012)"
              fill="#575a89"
            />
            <path
              id="Path_77"
              data-name="Path 77"
              d="M496.645,114.644a16.1,16.1,0,0,0-9.144-7.076l-2.8,2.264,1.087-2.641a14.62,14.62,0,0,0-2.763-.162l-2.515,3.274,1.041-3.162a15.888,15.888,0,0,0-10.983,6.613c-3.2,4.673-3.742,11.172-.593,15.881.864-2.689,1.913-5.212,2.778-7.9a7.768,7.768,0,0,0,2.048.01l1.052-2.484.294,2.379c3.259-.288,8.094-.919,11.184-1.5l-.3-1.825,1.8,1.517c.947-.221,1.509-.421,1.462-.574,2.3,3.751,4.575,6.146,6.873,9.9C498.04,123.867,499.58,119.47,496.645,114.644Z"
              transform="translate(-318.448 -107.022)"
              fill="#2f2e41"
            />
            <ellipse
              id="Ellipse_42"
              data-name="Ellipse 42"
              cx="0.931"
              cy="1.886"
              rx="0.931"
              ry="1.886"
              transform="translate(176.503 17.896)"
              fill="#ffb8b8"
            />
            <path
              id="Path_78"
              data-name="Path 78"
              d="M831.358,678.259c.4,13.737-7.532,18.771-17.483,19.065q-.347.01-.69.013-.692.005-1.371-.023c-9-.378-16.122-5.214-16.491-17.989-.381-13.221,15.829-30.4,17.045-31.669h0l.07-.073S830.961,664.523,831.358,678.259Z"
              transform="translate(-505.094 -412.285)"
              fill="#6c63ff"
            />
            <path
              id="Path_79"
              data-name="Path 79"
              d="M826.311,695.245l6.321-9.515-6.308,10.539.013,1.071q-.692.005-1.371-.023l.313-13.763-.009-.106.012-.02.03-1.3-6.922-10.174,6.914,9.2.025.275.237-10.4-5.979-10.548,6,8.721-.063-21.544v-.072l0,.07.4,16.979,5.449-6.9-5.431,8.36.119,9.3,5.014-9.078-5,10.445.066,5.172,7.292-12.645-7.27,14.45Z"
              transform="translate(-518.247 -412.287)"
              fill="#3f3d56"
            />
            <path
              id="Path_80"
              data-name="Path 80"
              d="M295.358,631.259c.4,13.737-7.532,18.771-17.483,19.065q-.347.01-.69.013-.692.005-1.371-.023c-9-.378-16.122-5.214-16.491-17.989-.381-13.221,15.829-30.4,17.045-31.669h0l.07-.073S294.961,617.523,295.358,631.259Z"
              transform="translate(-199.567 -385.743)"
              fill="#6c63ff"
            />
            <path
              id="Path_81"
              data-name="Path 81"
              d="M290.312,648.245l6.321-9.515-6.308,10.539.013,1.071q-.692.005-1.371-.023l.314-13.763-.009-.106.012-.02.03-1.3-6.922-10.174,6.914,9.2.025.275.237-10.4-5.979-10.548,6,8.721-.063-21.544v-.072l0,.07.4,16.979,5.449-6.9-5.431,8.36.119,9.3,5.014-9.078-5,10.445.066,5.172,7.292-12.645-7.27,14.45Z"
              transform="translate(-212.72 -385.746)"
              fill="#3f3d56"
            />
            <path
              id="Path_82"
              data-name="Path 82"
              d="M715.609,739.188c.233,8.063-4.421,11.018-10.262,11.191q-.2.006-.405.007-.406,0-.8-.014c-5.282-.222-9.463-3.06-9.68-10.559-.224-7.76,9.291-17.843,10-18.589h0l.041-.043S715.377,731.125,715.609,739.188Z"
              transform="translate(-447.601 -453.847)"
              fill="#6c63ff"
            />
            <path
              id="Path_83"
              data-name="Path 83"
              d="M712.647,749.158l3.71-5.585-3.7,6.186.008.628q-.406,0-.8-.014l.184-8.079-.005-.062.007-.012.018-.763L708,735.486l4.058,5.4.014.161.139-6.1-3.509-6.191,3.519,5.119-.037-12.646v0l.233,9.966,3.2-4.048-3.188,4.907.07,5.46,2.943-5.328-2.932,6.131.039,3.036,4.28-7.423-4.267,8.481Z"
              transform="translate(-455.321 -453.849)"
              fill="#3f3d56"
            />
            <path
              id="Path_84"
              data-name="Path 84"
              d="M1079.55,158.054l.038-.12c-.005.017-.012.034-.017.052Z"
              transform="translate(-667.111 -135.775)"
              fill="#2f2e41"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export default TeamRep;
